import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04b1d88e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "textarea-container__left-slot"
}
const _hoisted_2 = { class: "textarea-container__textarea-wrapper" }
const _hoisted_3 = { class: "textarea-container__textarea-label" }
const _hoisted_4 = { style: {"margin-top":"1.75rem","margin-bottom":"0.125rem"} }
const _hoisted_5 = ["contenteditable", "maxlength", "placeholder", "autocomplete", "spellcheck"]
const _hoisted_6 = {
  key: 1,
  class: "textarea-container__right-slot"
}

import {
  PropType,
  computed,
  onMounted,
  ref,
  useSlots,
  watch,
} from "vue";
import { TirPmScrollbar } from "tir-pm-scrollbar";

/** Слоты для кастомного контента */

export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-textarea',
  props: {
  /** Значение */
  modelValue: {
    type: String,
    default: "",
  },
  /** Лэйбл */
  label: {
    type: String as PropType<string>,
    default: "",
  },
  /** Заголовок */
  title: {
    type: String as PropType<string>,
    default: "",
  },
  /** Нужно ли автозаполнение */
  isAutocomplete: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /** Плейсхолдер */
  placeholder: {
    type: String as PropType<string>,
    default: "",
  },
  /** Показывать ли подсказку всегда */
  isShowHintDefault: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /** Показывать ли подсказку в данный момент */
  isShowHint: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /** Показывать ли подсказку вообще, есть ли она, зарезервировать место для подсказки */
  isWithHint: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  /** Ошибка */
  isWithError: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /** Успешное состояние */
  isWithSuccess: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /** Дизейбл */
  isDisabled: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /** Только для чтения */
  isReadonly: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /** Максимальная длина */
  maxLength: {
    type: String as PropType<string>,
    default: undefined,
  },
  /** Автофокус */
  autoFocus: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /** Автовыделение всего контента в инпуте */
  autoSelect: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  /** Максимальная высота */
  maxHeight: {
    type: String,
    default: "2.5rem",
  },
  /**Минимальная высота */
  minHeight: {
    type: String,
    default: "2.5rem",
  },
  /**Проверять текст на ошибки */
  spellcheck: {
    type: Boolean,
    default: true,
  },
},
  emits: ["update:modelValue", "focus", "blur", "enter", "input"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;

const slots = useSlots();

/** Пропсы компонента */




/** Стейт фокуса */
const isFocus = ref(false);
/** Ссылка на поле */
const $contenteditable = ref<HTMLTextAreaElement>();

/** Вычисляемое свойство для автозаполнения */
const computedIsAutocomplete = computed(() =>
  props.isAutocomplete ? "on" : "off"
);

/** Проверка наличия кастомного контента слева */
const isLeftTextareaAddons = computed(() => slots.leftTextareaAddons?.());
/** Проверка наличия кастомного контента справа */
const isRightTextareaAddons = computed(() => slots.rightTextareaAddons?.());

/** Связывание значения с пропом modelValue */
const value = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

/** Обработчик события ввода */
const onInput = (event: InputEvent) => {
  if (!$contenteditable.value) return;

  const textContent =
    $contenteditable.value.innerText === "\n"
      ? ""
      : $contenteditable.value.innerText;
  emit("input", event);
  value.value = textContent;
};

/** Обработчик события beforeinput для предотвращения форматирования */
const onBeforeInput = (event: InputEvent) => {
  if (event.inputType.startsWith("format")) {
    event.preventDefault();
  }
};

/** Обработчик вставки текста без форматирования */
const onPaste = (event: ClipboardEvent) => {
  event.preventDefault();
  // @ts-ignore
  const clipboardData = event.clipboardData || window.clipboardData;
  const text = clipboardData?.getData("text") || "";
  document.execCommand("insertText", false, text);
};

/**Получение узла и смещения для установки каретки по координатам мыши */
const getCaretPositionFromMouse = (
  element: HTMLElement,
  x: number,
  y: number
) => {
  let range;

  // Проверяем, какой метод доступен
  if (typeof document.caretRangeFromPoint === "function") {
    range = document.caretRangeFromPoint(x, y);
    // @ts-ignore
  } else if (typeof document.caretPositionFromPoint === "function") {
    // @ts-ignore
    const position = document.caretPositionFromPoint(x, y);
    if (position) {
      return {
        node: position.offsetNode,
        offset: position.offset,
      };
    }
  }

  // Если используется caretRangeFromPoint
  if (range) {
    return {
      node: range.startContainer,
      offset: range.startOffset,
    };
  }

  // Если не удалось найти позицию каретки
  return { node: element, offset: 0 };
};

/**Обработчик события drop */
const onDrop = (event: DragEvent) => {
  event.preventDefault();
  const data = event.dataTransfer?.getData("text/plain"); // Извлекаем только текст
  if (data && $contenteditable.value) {
    // Получаем координаты дропа
    const x = event.clientX;
    const y = event.clientY;
    const position = getCaretPositionFromMouse($contenteditable.value, x, y);
    const range = document.createRange();
    range.setStart(position.node, position.offset);
    range.collapse(true);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand("insertText", false, data);
  }
};

/** Фокусировка на поле */
const focus = () => {
  if (!$contenteditable.value) return;
  try {
    // Фокусируем элемент
    $contenteditable.value.focus();
    
    // Получаем Selection API
    const selection = window.getSelection();
    if (!selection) return;
    
    // Создаём новый диапазон
    const range = document.createRange();
    
    // Выбираем последний дочерний узел или сам элемент, если дочерних нет
    const lastChild = $contenteditable.value.lastChild || $contenteditable.value;
    
    // Устанавливаем позицию в конец содержимого
    const lastOffset = lastChild.textContent?.length || 0;
    range.setStart(lastChild, lastOffset);
    range.setEnd(lastChild, lastOffset);
    
    // Применяем диапазон
    selection.removeAllRanges();
    selection.addRange(range);
  } catch (e) {
    console.error(e);
  }
};

/** Выделение всего текста */
const select = () => $contenteditable.value?.select();

/** Проверка автофокуса и автовыделения */
const checkAutofocusOrAutoselect = () => {
  if (!$contenteditable.value) return;

  if (props.autoSelect) {
    select();
    return;
  }

  if (props.autoFocus) {
    focus();
    return;
  }
};

/** Обработчик клика вне элемента для фокуса */
const clickFocusOutside = () => {
  if (props.isDisabled && isFocus.value) return;
  if ($contenteditable.value) $contenteditable.value.focus();
};

/** Обработчик фокуса */
const onFocus = (e: FocusEvent) => {
  if (props.isDisabled) return;
  isFocus.value = true;
  emit("focus", e);
};

/** Обработчик потери фокуса */
const onBlur = (e: FocusEvent) => {
  if (props.isDisabled) return;
  isFocus.value = false;
  emit("blur", e);
};

/**Обработчик события keydown */
const onKeydown = (e: KeyboardEvent) => {
  if(e.key === "Enter") {
    emit("enter", e);
  }
}

/** Наблюдатель за изменением modelValue */
watch(
  () => props.modelValue,
  (newValue) => {
    if ($contenteditable.value) {
      const textContent =
        $contenteditable.value.innerText === "\n"
          ? ""
          : $contenteditable.value.innerText;
      const isChanged = textContent !== newValue;
      if (isChanged) $contenteditable.value.innerText = newValue;
    }
  }
);

/** Инициализация значений после монтирования компонента */
onMounted(() => {
  if ($contenteditable.value) {
    $contenteditable.value.innerText = props.modelValue;
  }
  checkAutofocusOrAutoselect();
});

/** Экспозиция публичных методов для внешнего использования */
__expose({
  focus,
  select,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["textarea", {
      'textarea--focused': isFocus.value,
      'textarea--disabled': __props.isDisabled,
    }]),
    onClick: clickFocusOutside
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["textarea-container", {
        'textarea-container--focused': isFocus.value,
        'textarea-container--with-value': value.value,
        'textarea-container--error': __props.isWithError,
        'textarea-container--success': __props.isWithSuccess,
        'textarea-container--disabled': __props.isDisabled,
      }])
    }, [
      (isLeftTextareaAddons.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "lefttextareaAddons")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.label), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(TirPmScrollbar), {
            style: _normalizeStyle({ maxHeight: __props.maxHeight, minHeight: __props.minHeight }),
            "show-on-hover": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "textarea-container__textarea",
                contenteditable: !__props.isDisabled && !__props.isReadonly,
                ref_key: "$contenteditable",
                ref: $contenteditable,
                maxlength: __props.maxLength,
                placeholder: __props.placeholder,
                tabindex: "0",
                autocomplete: computedIsAutocomplete.value,
                spellcheck: __props.spellcheck,
                onInput: onInput,
                onFocus: onFocus,
                onBlur: onBlur,
                onBeforeinput: onBeforeInput,
                onPaste: onPaste,
                onDrop: onDrop,
                onKeydown: onKeydown
              }, null, 40, _hoisted_5)
            ]),
            _: 1
          }, 8, ["style"])
        ])
      ]),
      (isRightTextareaAddons.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "righttextareaAddons")
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (__props.isWithHint)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["textarea__hint-message", {
        'textarea__hint-message--error': __props.isWithError,
        'textarea__hint-message--show': __props.isShowHint,
        'textarea__hint-message--success': __props.isWithSuccess,
      }])
        }, [
          _renderSlot(_ctx.$slots, "hintMessage")
        ], 2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})